import React from "react";
import * as S from "./styles";
import Card from "./Card";

function Flotta() {
  return (
    <S.Page>
      <Card
        title="LA NOSTRA FLOTTA"
        url="https://remote.fsairlines.net/v1/fleet.php?rvi=49186&title=off"
        full
        expand
      />
    </S.Page>
  );
}

export default Flotta;
